import React, { useState } from 'react';
import { useLazyQuery, gql } from '@apollo/client';
import { useParams } from 'react-router-dom';
import Input from 'Components/Input/Input';
import { logger } from 'RootShared/utility/ErrorLogger';

export const getUploadBuildUrl = gql`
  query uploadBuildUrl($clientContractId: Int!, $fileName: String!) @api(name: root) {
    uploadBuildUrl(clientContractId: $clientContractId, fileName: $fileName)
  }
`;

const FileUploader = (props) => {
  const { data, name, acceptTypes, fileFormatHelper, inputId, getBase64, getFile, sendFileMethod } = props;
  const { id } = useParams();

  const [isInvalidFromat, setInvalidFormat] = useState(false);
  const [isFileNotUpload, setFileNotUpload] = useState(false);
  const [newfile, setFile] = useState();

  const [getUrl] = useLazyQuery(getUploadBuildUrl, {
    onCompleted: (data) => {
      getFile({ ...newfile, url: data.uploadBuildUrl });
      setFileNotUpload(false);
    },
    onError: (error) => {
      logger.error(error);
      setFileNotUpload(true);
    },
  });

  return (
    <Input
      label="Upload file"
      name={name}
      variant="input-file"
      inputFileIcon="icon-done"
      id={inputId}
      acceptTypes={acceptTypes}
      helper={
        (isInvalidFromat ? fileFormatHelper : null) || (isFileNotUpload ? 'File do not upload. Please try again' : null)
      }
      helperVariant={isInvalidFromat || isFileNotUpload ? 'erorr' : null}
      callback={(e) => {
        const file = e.target.files[0];
        const name = file.name;
        let fileType;
        let system;
        if (name.endsWith('apk')) {
          fileType = 'app';
          system = 'android';
        } else if (name.endsWith('ipa')) {
          fileType = 'app';
          system = 'ios';
        } else if (name.endsWith('pdf') || name.endsWith('doc') || name.endsWith('docx') || name.endsWith('txt')) {
          fileType = 'log';
        } else {
          setInvalidFormat(true);
        }

        if (sendFileMethod === 'google-storage') {
          getUrl({
            variables: {
              clientContractId: id ? id : data.clientContract.id,
              fileName: name,
            },
          });
          setFile({ type: fileType, file, system: system });
        } else {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            const payload = {};
            if (fileType === 'app') {
              payload.appFileBase64 = reader.result.split(',')[1];
              payload.appFileName = name;
              payload.system = system;
            } else {
              payload.changelogBase64 = reader.result.split(',')[1];
              payload.changelogName = name;
            }

            getBase64(payload);
          };
        }

        setInvalidFormat(false);
      }}
    />
  );
};

export default FileUploader;
